import React, { useState, useEffect } from "react"
import ParticipantRoleApi from "../../services/participantRole";
import Page from "../Page"
import ParticipantRolesTable from "../../tables/ParticipantRolesTable"
import DashboardHeader from '../../components/DashboardHeader';
import { PopupboxContainer } from 'react-popupbox';
import {useParams} from "react-router-dom";

function ParticipantsPage(props) {
    const [roles, setRoles] = useState([]);
    const participantRoleApi = new ParticipantRoleApi(props.token);
    const [search, setSearch] = useState('');
    const { organizationId, eventId } = useParams();

    const fetch = () => {
        participantRoleApi.getRoles().then((result) => {
            setRoles([...result])
        })
    }

    useEffect(() => {
        fetch()
    }, []);

    // Search
    const __handleSearch = (event) => {
        setSearch(event.target.value);
        if (event.target.value !== '') {
            let search_results = roles.filter((item) => item.name.toLowerCase().includes(event.target.value.toLowerCase())
            );
            setRoles([...search_results]);
        }
        else {
            fetch(eventId)
        }
    };
    
    return (
        <div className='dashboard-content'>
            <DashboardHeader
                btnText="New Role" link={`/organization/${organizationId}/event/${eventId}/participant/role/new`} />
            <div className='dashboard-content-container'>
                <div className='dashboard-content-header'>
                    <h2>Participant Roles</h2>
                    <div className='dashboard-content-search'>
                        <input
                            type='text'
                            value={search}
                            placeholder='Search..'
                            className='dashboard-content-input'
                            onChange={e => __handleSearch(e)} />
                    </div>
                </div>
                <div className="organizations-custom-popup">
                    <PopupboxContainer />
                </div>
                    {
                        roles.length> 0 ?
                            <ParticipantRolesTable roles={roles} {...props} refresh={()=>fetch()} eventId={eventId} organizationId={organizationId}/>
                            :
                            <div className='dashboard-content-footer'>
                                <span className='empty-table'>No data</span>
                            </div> 
                    }
            </div>
        </div>
    )
}

export default ParticipantsPage